<template>
    <v-container fuild>
        <v-card flat>
            <v-card-title>Forms
            </v-card-title>
            <v-card-text>
                * To add new form, update a form or delete a form, please contact ARS.
            </v-card-text>
        </v-card>
        <v-card flat>
            <v-card-title>
                <template>
                    <v-row>
                        <v-col cols="8">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Map" single-line
                                hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </template>
            </v-card-title>
            <v-data-table :loading="loading" :headers="headers" :items="getForms" :search="search" item-key="id"
                single-expand sort-by="formName" sort-desc @click:row="getForm">
                <template v-slot:item.formName="{ item }">
                    <span>
                        {{ item.formName }}
                    </span>
                </template>
                <template v-slot:item.formCategory="{ item }">
                    <span>
                        {{ item.formCategory }}
                    </span>
                </template>
                <template v-slot:item.documentType="{ item }">
                    {{ item.documentType }}
                </template>
                <template v-slot:item.updated_at="{ item }">
                    {{ item.updated_at | formatDate }}
                </template>
                <template v-slot:item.documentUrl="{ item }">
                    {{ item.documentUrl | trimLength }} <v-icon color="primary" class="mx-2"
                        @click="copyToClipboard(item.documentUrl)">mdi-content-copy</v-icon>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
    name: 'formManagement',
    data() {
        return {
            loading: false,
            search: "",
            height: window.innerHeight,
            headers: [
                { text: 'Form Name', value: 'formName', align: 'start' },
                { text: 'Category', value: 'formCategory' },
                { text: 'Form Type', value: 'documentType' },
                { text: 'Updated At', value: 'updated_at', align: 'start' },
                { text: 'Document URL', value: 'documentUrl' }
            ],
        }
    },
    computed: {
        ...mapGetters(['getForms'])
    },
    methods: {
        getForm(item) {
            this.$store.dispatch('setSelectedForm', item);
            this.$store.dispatch('setViewForm', true);
        },
        copyToClipboard(url) {
            navigator.clipboard.writeText(url).then(() => alert('Link copied to clipboard!'))
                .catch(err => console.error('Failed to copy: ', err));
        }
    },
    mounted() {
        this.$store.dispatch('pullForms');
        this.$store.dispatch('pullFormCategories');
    },
    filters: {
        formatDate(val) {
            if (!val) { return '-' }
            return moment(val).format('L')
        },
        trimLength(val) {
            if (typeof val !== 'string') return val
            if (val === null) return val
            if (val === '') return val
            if (val.length <= 60) { return val }
            return `${val.substring(0, 45)}...`
        }
    },
}
</script>